/* ==========================================================================
   Paola & Joy — product template behaviour.
   Variant selection, availability, button label, media, sticky bar.
   Every string comes from the section settings; nothing is written here.
   ========================================================================== */
(function () {
  function money(cents, format) {
    var value = cents / 100;
    function withCommas(n, dp) {
      var parts = n.toFixed(dp).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return (format || '${{amount}}')
      .replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
        switch (name) {
          case 'amount_no_decimals': return withCommas(value, 0);
          case 'amount_with_comma_separator': return withCommas(value, 2).replace(/,/g, ' ').replace('.', ',');
          case 'amount_no_decimals_with_comma_separator': return withCommas(value, 0).replace(/,/g, ' ');
          default: return withCommas(value, 2);
        }
      })
      .replace(/<[^>]*>/g, '');
  }

  function init(root) {
    if (root.dataset.pjPdpReady === 'true') return;
    root.dataset.pjPdpReady = 'true';

    var dataEl = root.querySelector('[data-pj-pdp-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data.variants || !data.variants.length) return;

    var section = root.closest('.pj-section') || document;
    var settings = root.dataset;
    var fmt = data.moneyFormat;
    var lowThreshold = parseInt(settings.lowThreshold, 10) || 6;
    var isPreorder = settings.isPreorder === 'true';
    var setOption = settings.setOption || '';

    /* Availability strings live on the wrapper so they stay merchant-editable. */
    var strings = {};
    ['availInStock', 'availLow', 'availOut', 'availFinal', 'availPreorder', 'instalSuffix'].forEach(function (k) {
      strings[k] = root.dataset[k] || '';
    });

    var chosen = data.options.map(function (_, i) {
      var cur = data.variants.filter(function (v) { return v.id === data.current; })[0] || data.variants[0];
      return cur.options[i];
    });

    function match(opts) {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    function sellable(v) {
      if (!v) return false;
      if (!v.tracked) return true;
      if (v.policy === 'continue') return true;
      return v.qty > 0;
    }

    function current() { return match(chosen) || data.variants[0]; }

    /* An option value is unavailable when no sellable variant exists with it,
       holding every other currently chosen option steady. */
    function valueAvailable(optIndex, value) {
      var probe = chosen.slice();
      probe[optIndex] = value;
      var v = match(probe);
      return sellable(v);
    }

    function setOptionValue(name, value) {
      var i = data.options.indexOf(name);
      if (i === -1) return;
      chosen[i] = value;
      /* If that leaves an impossible combination, slide the other options to
         the first combination that does exist rather than dead-ending. */
      if (!match(chosen)) {
        var fallback = data.variants.filter(function (v) { return v.options[i] === value; })[0];
        if (fallback) chosen = fallback.options.slice();
      }
      render();
    }

    root.querySelectorAll('[data-pj-pdp-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setOptionValue(btn.dataset.pjPdpOption, btn.dataset.pjPdpValue);
      });
    });

    /* ---- Quantity ---- */
    var qtyNum = root.querySelector('[data-pj-pdp-qtynum]');
    root.querySelectorAll('[data-pj-pdp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = Math.max(1, (parseInt(qtyNum.value, 10) || 1) + parseInt(btn.dataset.pjPdpQty, 10));
        qtyNum.value = next;
        render();
      });
    });
    if (qtyNum) qtyNum.addEventListener('change', function () {
      qtyNum.value = Math.max(1, parseInt(qtyNum.value, 10) || 1);
      render();
    });

    /* ---- Media ---- */
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pj-pdp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pj-pdp-thumb]'));
    var counter = root.querySelector('[data-pj-pdp-counter]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var strip = root.querySelector('.pj-pdp__thumbs');
    var mediaIndex = 0;

    function goTo(i) {
      if (!slides.length) return;
      /* Wrap rather than stop, matching the Robyn gallery: an arrow that does
         nothing at the last image reads as broken. */
      mediaIndex = (i + slides.length) % slides.length;
      var cur = mediaIndex;

      slides.forEach(function (s, n) {
        var on = n === cur;
        s.style.opacity = on ? '1' : '0';
        s.style.pointerEvents = on ? 'auto' : 'none';
        s.classList.toggle('is-active', on);
        /* A slide that is only faded out keeps playing, so a shopper who
           moves on would still hear it. Stop it when it leaves. */
        if (!on) {
          var vid = s.querySelector('video');
          if (vid && !vid.paused) vid.pause();
        }
      });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === cur);
        t.setAttribute('aria-selected', n === cur ? 'true' : 'false');
      });
      if (counter) counter.textContent = pad(cur + 1) + ' / ' + pad(slides.length);

      /* Drag the active thumb into view when the strip has scrolled past it.
         scrollLeft rather than scrollIntoView, which can also scroll the PAGE
         and yank the shopper away from the image they just changed. */
      var active = thumbs[cur];
      if (strip && active) {
        var left = active.offsetLeft;
        var right = left + active.offsetWidth;
        if (left < strip.scrollLeft) {
          strip.scrollLeft = left - 12;
        } else if (right > strip.scrollLeft + strip.clientWidth) {
          strip.scrollLeft = right - strip.clientWidth + 12;
        }
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.pjPdpThumb, 10)); });
    });

    var mediaPrev = root.querySelector('[data-pj-pdp-prev]');
    var mediaNext = root.querySelector('[data-pj-pdp-next]');
    if (mediaPrev) mediaPrev.addEventListener('click', function () { goTo(mediaIndex - 1); });
    if (mediaNext) mediaNext.addEventListener('click', function () { goTo(mediaIndex + 1); });

    /* ---- Render ---- */
    function render() {
      var v = current();
      var qty = parseInt(qtyNum && qtyNum.value, 10) || 1;

      /* Chips and pills */
      root.querySelectorAll('[data-pj-pdp-option]').forEach(function (btn) {
        var name = btn.dataset.pjPdpOption;
        var i = data.options.indexOf(name);
        var on = i > -1 && chosen[i] === btn.dataset.pjPdpValue;
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
        if (i > -1) {
          /* Unavailable values stay visible, struck through — never removed. */
          btn.dataset.unavailable = valueAvailable(i, btn.dataset.pjPdpValue) ? 'false' : 'true';
        }
      });
      root.querySelectorAll('[data-pj-pdp-selected]').forEach(function (el) {
        var i = data.options.indexOf(el.dataset.pjPdpSelected);
        if (i > -1) el.textContent = chosen[i];
      });

      /* Price */
      var priceEl = root.querySelector('[data-pj-pdp-price]');
      var compareEl = root.querySelector('[data-pj-pdp-compare]');
      var saveEl = root.querySelector('[data-pj-pdp-save]');
      if (priceEl) priceEl.textContent = money(v.price, fmt);
      if (compareEl) compareEl.textContent = v.compare > v.price ? money(v.compare, fmt) : '';
      /* 1B states the saving as an amount, not a percentage. */
      if (saveEl && v.compare > v.price) {
        saveEl.textContent = (root.dataset.saveWord || 'Save') + ' ' +
          money(v.compare - v.price, fmt).replace(/\.00$/, '');
      }

      var instalEl = root.querySelector('[data-pj-pdp-instal]');
      if (instalEl) {
        var n = parseInt(root.dataset.instalmentCount, 10) || 4;
        instalEl.textContent = 'or ' + n + ' × ' + money(Math.round(v.price / n), fmt) + ' ' + strings.instalSuffix;
      }

      /* Availability */
      var availEl = root.querySelector('[data-pj-pdp-avail]');
      var left = v.tracked ? Math.max(0, v.qty) : null;
      if (availEl) {
        var text;
        if (isPreorder) {
          var run = parseInt(root.dataset.runSize, 10) || 0;
          var reserved = parseInt(root.dataset.reserved, 10) || 0;
          text = strings.availPreorder.replace('[reserved]', reserved).replace('[run]', run);
        } else if (!sellable(v)) {
          text = strings.availOut;
        } else if (left !== null && left <= lowThreshold) {
          /* Low stock. Final sale gets its own wording, but the count is only
             published once it is genuinely low — the same threshold every
             other product uses. Previously the final-sale branch sat above
             this test, so a final-sale product announced its exact inventory
             at any level ("74 left" on 74 units) instead of just "In stock". */
          text = root.classList.contains('pj-pdp--final')
            ? strings.availFinal.replace('[n]', left)
            : strings.availLow.replace('[n]', left);
        } else {
          text = strings.availInStock;
        }
        availEl.textContent = text;
      }

      /* Button label */
      var label;
      if (!sellable(v) && !isPreorder) {
        label = settings.soldoutLabel;
      } else if (isPreorder) {
        label = (settings.preorderLabel || '').replace('[date]', settings.shipDate || '');
      } else if (setOption && data.options.indexOf(setOption) > -1) {
        var chosenSet = chosen[data.options.indexOf(setOption)];
        label = (settings.addSetLabel || '').replace('[set]', (chosenSet || '').toLowerCase());
      } else {
        label = settings.addLabel;
      }
      if (settings.showPriceInLabel === 'true' && sellable(v)) {
        label += ' — ' + money(v.price * qty, fmt);
      }

      root.querySelectorAll('[data-pj-pdp-add], [data-pj-pdp-stickyadd]').forEach(function (b) {
        b.textContent = label;
        b.disabled = !sellable(v) && !isPreorder;
      });

      wireBackInStock(v, !sellable(v) && !isPreorder);

      /* No standalone price in the sticky bar: the button label already ends
         in the price, so it was printed twice on top of each other. */

      var input = root.querySelector('[data-pj-pdp-variant]');
      if (input) input.value = v.id;

      /* Keep the address bar honest so a share link lands on the same variant. */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
    }

    /* ------------------------------------------------------------------
       Back in stock — Ordersify Restocked Alerts.
       Ordersify scans for elements with data-osf-type="oos" and replaces
       their contents with its own button, which opens the alert popup. We
       hand it only the selected variant, so the alert is for what the
       shopper is actually looking at. If the app is absent the buy form
       simply stays as it is, showing the disabled sold-out button.
       ---------------------------------------------------------------- */
    var bisTries = 0;
    function wireBackInStock(v, soldOut) {
      var host = root.querySelector('[data-pj-bis]');
      var buyForm = root.querySelector('[data-pj-pdp-form]');
      if (!host) return;

      if (!soldOut) {
        host.hidden = true;
        host.removeAttribute('data-osf-type');
        if (buyForm) buyForm.hidden = false;
        return;
      }

      var api = window.ORDERSIFY_BIS;
      if (!api || typeof api.addFlexibleOOSButtons !== 'function' || !api.product) {
        /* The SDK loads async; give it a few beats before giving up. */
        if (bisTries++ < 20) setTimeout(function () { wireBackInStock(v, soldOut); }, 250);
        return;
      }

      /* Ordersify posts a `handle` (and the real variant object) straight out
         of whatever product we hand it, and its API rejects the submission
         with 400 "handle is a required field" if they are missing — so pass
         the genuine product, narrowed to the selected variant. */
      var p = api.product;
      var variant = (p.variants || []).filter(function (x) {
        return String(x.id) === String(v.id);
      })[0] || { id: v.id, title: 'Default Title', available: false };

      host.setAttribute('data-osf-type', 'oos');
      host.setAttribute('data-osf-id', p.id);
      host.setAttribute('data-osf-oos-type', 'all');
      host.setAttribute('data-osf-product', JSON.stringify({
        id: p.id,
        handle: p.handle,
        title: p.title,
        available: false,
        variants: [variant]
      }));
      host.hidden = false;
      api.addFlexibleOOSButtons();

      /* Ordersify only injects if it agrees the variant is unavailable. */
      var sticky = root.querySelector('[data-pj-pdp-stickyadd]');
      if (host.querySelector('button')) {
        if (buyForm) buyForm.hidden = true;
        /* The sticky bar opens the popup, so it must not stay disabled. */
        if (sticky) sticky.disabled = false;
      } else {
        host.hidden = true;
        if (buyForm) buyForm.hidden = false;
      }
    }

    /* ---- Add to cart ---- */
    var form = root.querySelector('[data-pj-pdp-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var v = current();
        var qty = parseInt(qtyNum && qtyNum.value, 10) || 1;
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
        })
          .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
          .then(function (res) {
            if (!window.PJToast) return;
            if (!res.ok) {
              window.PJToast.show(res.body.description || res.body.message || 'That one is unavailable.', { hideBag: true });
              return;
            }
            window.PJToast.show(settings.toast + (v.title && v.title !== 'Default Title' ? ' — ' + v.title : ''));
            window.PJToast.refreshCartCount();
          })
          .catch(function () {
            if (window.PJToast) window.PJToast.show('Something went wrong. Please try again.', { hideBag: true });
          });
      });
    }

    var stickyAdd = root.querySelector('[data-pj-pdp-stickyadd]');
    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        /* Sold out: open the back-in-stock popup rather than submitting. */
        var bisBtn = root.querySelector('[data-pj-bis] button');
        if (bisBtn) { bisBtn.click(); return; }
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    goTo(0);
    render();
  }

  function boot() { document.querySelectorAll('[data-pj-pdp]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
